<section *ngIf="!loading && storyPreview && storyPreview.length > 0">
	<div class="w-full flex flex-col gap-2 items-center px-4 md:px-0 pb-4">
		<h2 [ngClass]="isSizeMd && !madeToOrderEnabled ? 'fb-sub-header-desktop' : 'fb-sub-header'"
			class="fb-font-dm black-text font-medium mb-2">
			Discover The Craft
		</h2>
		<div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-3">
			<a  *ngFor="let story of storyPreview"
				routerLink="/stories/{{story.slug}}/{{story.id}}"
				class="flex flex-col items-center rounded"
				[ngClass]="story.storyContentCategory.storyContentType.toLowerCase()">
				<img [src]="story.bannerImageMobile"
					 [alt]="story.title"
					 class="w-full rounded-t object-cover object-top h-[260px] sm:h-[300px]">
				<div class="w-full p-3 rounded-b">
					<h3 class="fb-font-dm fb-small-header black-text my-1 capitalize">
						{{story.title.toLowerCase()}}
					</h3>
					<p class="text-xs sm:text-sm primary-brown-text font-medium capitalize mb-2">
						{{story.storyContentCategory.name.toLowerCase()}} | Published on {{story.lastUpdatedTime? story.lastUpdatedTime: story.timeOfCreation | formatDate}}
					</p>
				</div>
			</a>
		</div>
	</div>
</section>
